<template>
  <v-card
    :style="`height: ${contentHeight}px;`"
    class="pa-3 overflow--y"
    flat
  >
    <div v-if="user.name" class="mb-2">
      <div class="caption gray-6--text text-capitalize">{{ $t('Common.employee') }}</div>
      <div class="text-capitalize">{{ user.name | textLowercase }}</div>
    </div>

    <div v-if="user.profile" class="mb-2">
      <div class="caption gray-6--text">{{ $t(`${namespace}.accessProfile`) }}</div>
      <div>{{ getProfileName(user.profile) }}</div>
    </div>

    <div v-if="user.email" class="mb-2">
      <div class="caption gray-6--text">{{ $t('Common.email') }}</div>
      <div>{{ user.email }}</div>
    </div>

    <div v-if="isValidArray(user.companies)" class="mb-2">
      <div class="caption gray-6--text text-capitalize">{{ $t('Common.companies') }}</div>
      <div v-for="company in user.companies" :key="company.id">
        {{ company.id }} - {{ company.name }}
      </div>
    </div>
  </v-card>
</template>

<script>
import { isArray, calcContentHeight, objectToArray } from 'utils/functions'

export default {
  name: 'Preview',
  props: {
    user: {
      type: Object
    }
  },
  data () {
    return {
      namespace: 'Views.UsersPage',
      contentHeight: null
    }
  },
  methods: {
    isValidArray (val) {
      return isArray(val)
    },

    calcContentHeight () {
      this.contentHeight = calcContentHeight()
    },

    getProfileName (value) {
      const profiles = objectToArray(this.$t('Views.UserPage.form.profiles'))
      const targetProfile = profiles.find(profile => profile.value === value)
      return targetProfile ? targetProfile.name : '-'
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.calcContentHeight)
  }
}
</script>
